module.exports = __webpack_public_path__ + "static/lounge2-d7f8da55c6196793fedb74f9dc1ec70b.jpg";